import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddDialogData } from 'src/app/page/masterdata/switch-points/switch-points.component';

@Component({
    selector: 'app-add-switch-point',
    templateUrl: './add-switch-point.component.html',
    styleUrls: ['./add-switch-point.component.scss'],
    standalone: false // NOSONAR
})
export class AddSwitchPointComponent implements OnInit {

  dynamicHeight: number;

  fiscalyear;
  switchPointID = "Auto assigned";
  switchPointCode;
  costPerM3;
  enableError: boolean = false;
  isAdd: boolean = false;
  
  action;
  heading;
  errormsg: string;

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, @Inject(MAT_DIALOG_DATA) public dataStore: AddDialogData,
   private readonly  dialogRef: MatDialogRef<AddSwitchPointComponent>) { 
      this.dynamicHeight = 0.665 * (window.innerHeight);
      this.ngxUiLoaderService.start("loader-01");
  
      this.ngxUiLoaderService.stop("loader-01");
  
      if (this.dataStore.performAction == 'EditCell') { // NOSONAR
        this.heading = "Edit";
        this.action = 'EditCell';
  
        this.switchPointID = this.dataStore.placeholder_switchPointID;
        this.switchPointCode = this.dataStore.placeholder_switchPointCode;
        this.costPerM3 = this.dataStore.placeholder_costPerM3;
      }
      else {
        this.fiscalyear = this.dataStore.placeholder_fiscalYear;
        this.heading = "Add";
        this.action = 'AddCell';
        this.isAdd = true;
      }
    }

  ngOnInit(): void { // NOSONAR 

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  public saveClick() {
    console.info("Fiscal Year", this.fiscalyear);
    console.info("Switch Point Id", this.switchPointID);
    console.info("Switch Point Code", this.switchPointCode);
    console.info("Cost Per M3", this.costPerM3);

    if (this.isAdd) {
      if (this.switchPointCode == '' || this.switchPointCode == null || this.switchPointCode == undefined || this.switchPointCode.trim().length == 0 || this.costPerM3 == null || this.costPerM3 == undefined) { // NOSONAR
        this.enableError = true;
        this.errormsg = 'Please fill in the required fields!';
      }else if (!this.switchPointCode || this.switchPointCode.trim().length < 4 || this.switchPointCode.trim().length > 5) {
        this.enableError = true;
        this.errormsg = 'Switch Point Code must be between 4 and 5 characters.';
        return;
      }
      else {
        this.dialogRef.close({
          event: this.action, data0: this.switchPointID, data1: this.fiscalyear,
          data2: this.switchPointCode, data3: this.costPerM3
        });
      }
    } else  if (this.costPerM3 == null || this.costPerM3 == undefined) { // NOSONAR
        this.enableError = true;
        this.errormsg = 'Please fill in the required fields!';
      }
      else {
        this.dialogRef.close({
          event: this.action, data0: this.switchPointID, data1: this.costPerM3
        });
      }
    }
  }


